import { APITimeline } from '@cxc/ui-kit/chart.js/components/timeline';
import { Chart } from '@cxc/ui-kit/chart.js/models';

import { Companies as _Companies } from '@models/API/companies';
import { Identity as _Identity } from '@models/API/identity/index';
import { Notify as _Notify } from '@models/API/notify/index';
import { Trusts as _Trusts } from '@models/API/trusts';
import { User as _User } from '@models/API/user.model';

export namespace API {
  export import User = _User;

  export import Identity = _Identity;
  export import Companies = _Companies;
  export import Trusts = _Trusts;
  export import Notify = _Notify;

  export type Chart = Chart.V1.Chart;
  export type Timeline = APITimeline;
}
